<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT" id="_idParaDest-4"> </p>
<p class="DED">This account is fiction, populated by characters who speak to the realities that women have long lived in silence. </p>
<p class="BT"><span class="CharOverride-3">Shame and isolation thrive in that silence. If it isn’t broken, this story will continue to repeat itself.</span></p>
<p class="BT"><span class="CharOverride-3">I dedicate this book to those who have spoken out.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802157409-3.vue?aa469852